<div class="bg-shui-base-2 rounded-md p-3 pl-6 sm:p-4 sm:pl-8 flex flex-col gap-3 sm:gap-6 relative cursor-pointer">
    <div class="absolute top-2 bottom-2 left-2 w-1 rounded-full" [style.background-color]="accentColor()"></div>
    <ng-content></ng-content>
</div>
